import { TenderApproversResponse } from '@Types/api/form';
import { Approver } from '@Types/api/form/tenderRequest/TenderApproversResponse';
import { toCapitalize } from '@Utils/toCapitalize';
import { SelectProps } from 'antd';

// {"approvers":null,"commercialApprovers":null,"technicalApprovers":null}

const transformResponseKey = (responseKey: string): string => {
  const result = responseKey.split(/(?=[A-Z])/);

  return result.map((item) => toCapitalize(item)).join(' ');
};

export const transformResponseToOptionGroups = (
  response: TenderApproversResponse
): SelectProps['options'] => {
  const result = Object.entries(response).map((item) => {
    const responseItem = item as [string, Approver[]];

    const transformedOptions =
      responseItem[1]?.map((approver) => ({
        label: approver.userName,
        value: String(approver.userId),
      })) || [];

    return {
      label: transformResponseKey(responseItem[0]),
      title: transformResponseKey(responseItem[0]),
      options: transformedOptions,
    };
  });

  return result;
};
